"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collection = exports.hideProps = void 0;
var collections_1 = require("../../requests/collections");
var items_1 = require("../../requests/items");
var defer_1 = require("../../services/utils/defer");
var EventEmitter_1 = require("../../services/EventEmitter/EventEmitter");
var utils_1 = require("../../services/utils");
var item_1 = require("../item/item");
function hideProps(props, object) {
    props.forEach(function (prop) {
        Object.defineProperty(object, prop, __assign(__assign({}, Object.getOwnPropertyDescriptor(object, prop)), { enumerable: false }));
    });
}
exports.hideProps = hideProps;
var Collection = /** @class */ (function (_super) {
    __extends(Collection, _super);
    function Collection(attributes) {
        var _this = _super.call(this) || this;
        _this.type = 'image';
        _this.title = '';
        _this.tags = [];
        _this.uniquePerUser = false;
        _this.thumbnailUrl = '';
        _this.publicProperties = {};
        _this.privateProperties = {};
        _this.items = [];
        _this._toDefaults();
        if (attributes) {
            _this._mergeProperties(attributes);
        }
        hideProps(['domain', '_events', '_eventsCount', '_maxListeners'], _this);
        return _this;
    }
    Collection.getAll = function (type, withItems) {
        var _this = this;
        if (type === void 0) { type = 'image'; }
        if (withItems === void 0) { withItems = true; }
        return collections_1.collectionsRequests.getAll(type, withItems).then(function (allModelsData) {
            return allModelsData.map(function (modelData) { return new _this(modelData); });
        });
    };
    Collection.get = function (collectionOrId) {
        var _this = this;
        return collections_1.collectionsRequests.get(collectionOrId).then(function (modelData) {
            return new _this(modelData);
        });
    };
    Collection.getAllOfEveryType = function (withItems) {
        var _this = this;
        if (withItems === void 0) { withItems = true; }
        return collections_1.collectionsRequests
            .getAllOfEveryType(withItems)
            .then(function (allModelsData) {
            return allModelsData.map(function (modelData) { return new _this(modelData); });
        });
    };
    Collection.prototype.get = function () {
        var _this = this;
        return collections_1.collectionsRequests.get(this.id).then(function (serverData) {
            _this._toDefaults();
            _this._mergeProperties(serverData);
            return _this;
        });
    };
    Collection.prototype.update = function (newFields) {
        var _this = this;
        Object.assign(this, newFields);
        return collections_1.collectionsRequests
            .partialUpdateProperties(this.id, this._toServerModel())
            .then(function (res) {
            _this._mergeProperties(res);
            return _this;
        });
    };
    Collection.prototype.save = function () {
        var _this = this;
        if (this.id) {
            return collections_1.collectionsRequests
                .updateProperties(this._toServerModel())
                .then(function (res) {
                _this._mergeProperties(res);
                return _this;
            });
        }
        return collections_1.collectionsRequests
            .create(__assign(__assign({}, this._toServerModel()), { items: this.itemsToJSON() }))
            .then(function (res) {
            _this._toDefaults();
            _this._mergeProperties(res);
            return _this;
        });
    };
    Collection.prototype.delete = function () {
        return collections_1.collectionsRequests.delete(this.id);
    };
    Collection.prototype.publish = function () {
        var _this = this;
        return collections_1.collectionsRequests.publish(this.id).then(function (res) {
            _this._mergeProperties(res);
            return _this;
        });
    };
    Collection.prototype.saveItems = function (items) {
        var _this = this;
        if (items === void 0) { items = this.items; }
        this._emitItemsEvents('pre-save', items);
        return this.callWithOrWithoutIds(items, items_1.itemsRequests.update, items_1.itemsRequests.createAsLast).then(utils_1.tap(function () { return _this._emitItemsEvents('post-save', items); }));
    };
    Collection.prototype.moveItemsToStart = function (items) {
        return this.callWithOrWithoutIds(items, items_1.itemsRequests.moveToStart, items_1.itemsRequests.createAsFirst);
    };
    Collection.prototype.moveItemsToEnd = function (items) {
        return this.callWithOrWithoutIds(items, items_1.itemsRequests.moveToEnd, items_1.itemsRequests.createAsLast);
    };
    Collection.prototype.moveItemsBefore = function (items, beforeItemOrId) {
        return this.callWithOrWithoutIds(items, items_1.itemsRequests.moveBefore, items_1.itemsRequests.createBefore, beforeItemOrId);
    };
    Collection.prototype.moveItemsAfter = function (items, afterItemOrId) {
        return this.callWithOrWithoutIds(items, items_1.itemsRequests.moveAfter, items_1.itemsRequests.createAfter, afterItemOrId);
    };
    Collection.prototype.deleteItems = function (items) {
        var _this = this;
        if (items === void 0) { items = this.items; }
        this._emitItemsEvents('pre-delete', items);
        return items_1.itemsRequests.delete(this, items).then(utils_1.tap(function () {
            _this.items = _this.items.filter(function (item) { return items.indexOf(item) === -1; });
            _this._emitItemsEvents('post-delete', items);
        }));
    };
    Collection.prototype.itemsToJSON = function () {
        return this.items.map(function (i) { return i.toJSON(); });
    };
    Collection.prototype._updateItems = function (serverItems, localItems) {
        var _this = this;
        serverItems.forEach(function (itemData, i) {
            var foundItem = localItems
                ? localItems[i]
                : _this._getIfHasItem(itemData);
            if (foundItem) {
                return foundItem._mergeProperties(itemData);
            }
            return new item_1.Item(_this, itemData);
        });
    };
    Collection.prototype._createItems = function (serverItems, localItems) {
        var _this = this;
        return serverItems.map(function (itemData, i) {
            var foundItem = localItems
                ? localItems[i]
                : _this._getIfHasItem(itemData);
            if (foundItem) {
                foundItem._mergeProperties(itemData);
                return foundItem;
            }
            return new item_1.Item(_this, itemData);
        });
    };
    Collection.prototype._emitItemsEvents = function (eventName, items) {
        items.forEach(function (item) { return item.emit(eventName, item); });
    };
    Collection.prototype._getIfHasItem = function (itemModel) {
        return this.items.find(function (item) {
            return Boolean(item === itemModel ||
                (itemModel && item.id && item.id === itemModel.id));
        });
    };
    Collection.prototype._mergeProperties = function (serverData) {
        var _a = utils_1.toClientModel(serverData), items = _a.items, otherData = __rest(_a, ["items"]);
        Object.assign(this, otherData);
        if (items && items.length) {
            this.items = this._createItems(items);
        }
    };
    Collection.prototype._toServerModel = function () {
        return {
            id: this.id,
            type: this.type,
            title: this.title,
            tags: this.tags,
            thumbnail_url: this.thumbnailUrl,
            unique_per_user: this.uniquePerUser,
            public_properties: this.publicProperties,
            private_properties: this.privateProperties,
        };
    };
    Collection.prototype._toDefaults = function () {
        this.id = void 0; // GUID assigned on collection creation
        this.type = 'image'; // Defines type of collection's content (for example, "audio", "image", "video", etc.)
        this.title = ''; // Title of the collection (may be empty)
        this.tags = []; // Optional tags
        this.uniquePerUser = false;
        this.thumbnailUrl = ''; // URL of the image representing this collection (may be empty)
        this.publicProperties = {}; // Collection-specific data, which will be published on /collections/publish request
        this.privateProperties = {}; // Collection-specific data, which will not be published (May be empty)
        if (this.items) {
            this.items.length = 0;
        }
        else {
            this.items = [];
        }
    };
    Collection.prototype.callWithOrWithoutIds = function (items, withIdRequest, withoutIdRequest) {
        var _this = this;
        var args = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            args[_i - 3] = arguments[_i];
        }
        var itemsWithIdsServerModel;
        var itemsWithoutIdsServerModel;
        var deferred = defer_1.defer();
        var uncompletedRequestsCount = 0;
        var mergeAndResolve = function (res, localItems) {
            uncompletedRequestsCount--;
            _this._updateItems(res, localItems);
            if (!uncompletedRequestsCount) {
                return deferred.resolve(items);
            }
        };
        var itemsWithIds = items.filter(function (item) {
            return item.id;
        });
        var itemsWithoutIds = items.filter(function (item) {
            return !item.id;
        });
        if (itemsWithIds.length && withIdRequest) {
            uncompletedRequestsCount++;
            itemsWithIdsServerModel = itemsWithIds.map(function (i) { return i.toJSON(); });
            withIdRequest.apply(void 0, __spreadArrays([this, itemsWithIdsServerModel], args)).then(function (res) {
                return mergeAndResolve(res, itemsWithIds);
            })
                .catch(deferred.reject);
        }
        if (itemsWithoutIds.length && withoutIdRequest) {
            uncompletedRequestsCount++;
            itemsWithoutIdsServerModel = itemsWithoutIds.map(function (i) { return i.toJSON(); });
            withoutIdRequest.apply(void 0, __spreadArrays([this, itemsWithoutIdsServerModel], args)).then(function (res) {
                return mergeAndResolve(res, itemsWithoutIds);
            })
                .catch(deferred.reject);
        }
        return deferred.promise();
    };
    __decorate([
        EventEmitter_1.withEventEmitter('get'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Collection.prototype, "get", null);
    __decorate([
        EventEmitter_1.withEventEmitter('update'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Collection.prototype, "update", null);
    __decorate([
        EventEmitter_1.withEventEmitter('save'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Collection.prototype, "save", null);
    __decorate([
        EventEmitter_1.withEventEmitter('delete'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Collection.prototype, "delete", null);
    __decorate([
        EventEmitter_1.withEventEmitter('publish'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Collection.prototype, "publish", null);
    __decorate([
        EventEmitter_1.withEventEmitter('saveItems'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], Collection.prototype, "saveItems", null);
    return Collection;
}(EventEmitter_1.EventEmitter));
exports.Collection = Collection;
//# sourceMappingURL=collection.js.map